<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="batchDeleteHandler">删除</el-button>
            <address-book-wyms isbutton @input="addUserConfirm" v-model="addressJson" :config="addressConfig" :schoolId="schoolId">添加用户</address-book-wyms>
            <el-input size="medium" class="search-input search-input--right" placeholder="用户名称"
                      v-model="userName" @keyup.enter.native="getList">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
            </el-input>
        </div>

        <div >
            <el-table
                :height="windowHeight - 205"
                :data="dataList"
                style="width: 100%" border
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="头像"
                    align="center"
                >
                    <template slot-scope="scope">
                        <div class="avatar" :style="{backgroundImage: `url(${scope.row.avatar})`}"></div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="姓名"
                    align="center"
                    prop="name"
                >
                </el-table-column>
                <el-table-column
                    label="手机号"
                    align="center"
                    prop="mobile"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="deleteHandler(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size.sync="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';
    import AddressBookWyms from '@/components/AddressBook/AddressBookWyms';

    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';

    import {
        queryRoleUserList,
        insertRoleUser,
        deleteRoleUser
    } from '@/api/schoolManage';

    export default {
        name: 'schoolRoleUserList',
        data() {
            return {
                id: this.$route.query.id,
                schoolId: this.$route.query.schoolId,
                userName: '',
                dataList: [],
                multipleSelection:[],

                addressConfig: {
                    title: '选择用户',
                    depart: {target: 'user', departType: 't', userTypes: '1'},
                    SingleChose: false
                },
                addressJson: []
            }
        },
        components: {AddressBookWyms, BackTool},
        created() {
            this.queryRoleUserListFunc()

        },
        mixins: [windowResize, baseMixin],
        methods: {
            addUserConfirm(data) {
                if(!data.userJson || data.userJson.length === 0) {
                    this.$message.error('请选择用户');
                } else {
                    insertRoleUser({
                        roleId: this.id,
                        userIds: data.userJson.map(item => item.id).join(',')
                    })
                        .then(() => {
                            this.$message.success('添加成功');
                            this.addressJson = [];
                            this.getList();
                        })
                }
            },
            getList() {
                this.pagination.pageNo = 1;
                this.queryRoleUserListFunc();
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            sizeChangeHandler() {
                this.queryRoleUserListFunc();
            },
            currentChangeHandler() {
                this.queryRoleUserListFunc();
            },
            batchDeleteHandler() {
                if(this.multipleSelection.length === 0) {
                    this.$message.error('请选择要删除的角色');
                } else {
                    this.deleteHandler(this.multipleSelection.map(({id}) => id).join(','));
                }
            },
            deleteHandler(userIds) {
                this.$confirm('确认要删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    deleteRoleUser({
                        roleId: this.id,
                        userIds
                    })
                        .then(() => {
                            this.$message.success('删除成功');
                            this.queryRoleUserListFunc();
                        })
                });
            },
            queryRoleUserListFunc() {
                queryRoleUserList({
                    roleId: this.id,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    schoolId: this.schoolId,
                    userName: this.userName
                })
                    .then(data => {
                        this.dataList = data.dataList;
                        this.pagination.total = data.pagination.total;
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";
    .avatar {
        @include cover-bg;
        @include wh(30px, 30px);
        margin: 0 auto;
    }
    #moduleAppList{
      padding: 12px;
        .top {
    padding-bottom: 10px;
  }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolRole/schoolRoleUserList.vue